// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"46c6715c63f868fbbfd8","524":"039f7c29696fcd79e6e8","678":"e6409831095d7e1ba4c8","883":"b1a01d99645e92dd05d6"}[chunkId] + ".js";
};